import {
  FormControlLabel,
  MenuItem,
  Radio,
  SxProps,
  Theme,
} from "@mui/material";

import { SyntheticEvent } from "react";

const RadioMenuItem = (props: {
  value: string;
  label: string;
  selectedValue?: string;
  disabled?: boolean;
  sx?: SxProps<Theme>;
  onChange?: (event: SyntheticEvent, checked: boolean) => void;
}) => {
  const { value, label, selectedValue, onChange, disabled = false, sx } = props;
  const checked = selectedValue === value;

  return (
    <MenuItem
      sx={{
        paddingY: 0,
        cursor: disabled ? "not-allowed" : "pointer",
        ...sx,
      }}
    >
      <FormControlLabel
        value={value}
        disabled={disabled}
        control={
          <Radio
            checked={checked}
            disabled={disabled}
            sx={{
              "&.Mui-disabled.Mui-checked": {
                color: "rgba(25, 118, 210, 0.4)",
              },
            }}
          />
        }
        label={label}
        onChange={onChange}
      />
    </MenuItem>
  );
};

export default RadioMenuItem;
